import React, { useState, useRef, useEffect } from "react";
import ConfirmationModal from '../../../../../../Components/ConfirmationBox/ConfirmationModal';
import apiClient from "../../../../../../Config/apiClient";
import { showSuccessToast, showErrorToast } from "../../../../../../Context/Toaster/Toaster";
import { ClipLoader } from "react-spinners";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import './JobsList.scss';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

import editIcon from "../../../../../../Assets/images/edit-icon.svg";
import deleteIcon from "../../../../../../Assets/images/delete-icon.svg";
import filterIcon from "../../../../../../Assets/images/filter-icon.svg";
import clearIcon from "../../../../../../Assets/images/clear-icon.svg";
import searchIcon from "../../../../../../Assets/images/search-icon.svg";
import closeRedIcon from "../../../../../../Assets/images/close-red.svg";
import calendarIcon from "../../../../../../Assets/images/calender.svg";
import { DATE_FORMAT, DATE_MONTH_FORMAT, DATE_TIME_FORMAT } from "../../../Utils/Constants";
import AssignModal from "../AssignModal/AssignModal";
import Pagination from "../../../../../../Utils/Pagination/Pagination";

const jobsBaseUrl = process.env.REACT_APP_TC_JOBS_BASE_PATH;

const JobTableSection = ({
  jobs,
  jobsPerPage,
  currentPage,
  onPageChange,
  setJobsPerPage,
  totalJobs,
  startIndex,
  onSearchChange,
  searchTerm,
  setJobData,
  setShowModal,
  onFilterChange,
  filters,
  resetFilters,
  loading,
  setRefresh,
  canEditJobs,
  updateJobLocally
}) => {
  const totalPages = Math.ceil(totalJobs / jobsPerPage);

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setShowAssignModal(true);
  };

  const handleCloseModal = (updatedJob = null) => {
    setShowAssignModal(false);
    setSelectedJob(null);

    if (updatedJob && updateJobLocally) {
      updateJobLocally(updatedJob);
    }
  };

  const getUTCDateTime = (dateStr, isEnd = false) => {
    if (!dateStr || isNaN(new Date(dateStr).getTime())) return undefined;

    const date = new Date(dateStr);
    const fullDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      isEnd ? 23 : 0,
      isEnd ? 59 : 0,
      isEnd ? 59 : 0
    );

    return fullDate.toISOString();
  };

  let userRole = localStorage.getItem("userRole");
  try {
    userRole = JSON.parse(userRole);
  } catch {

  }
  const isUser = userRole?.trim().toLowerCase() === "truck-user";

  const [filterErrors, setFilterErrors] = useState({
    start_date: "",
    end_date: "",
    posted_date: "",
  });

  const filteredJobs = jobs.filter((job) => {
    const matchesSearch =
      !searchTerm ||
      (job.job_name && job.job_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (job.job_description && job.job_description.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (job.job_type && job.job_type.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesStatus =
      !filters.job_status ||
      (job.job_status &&
        job.job_status.trim().toLowerCase() === filters.job_status.trim().toLowerCase());

    return matchesSearch && matchesStatus;
  });


  const currentJobs = filteredJobs.slice(startIndex, startIndex + jobsPerPage);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterRef = useRef(null);
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);


  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLocalFilterChange = (key, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key.includes("start_date")) {
      setFilterErrors((prev) => ({ ...prev, start_date: "" }));
    } else if (key.includes("end_date")) {
      setFilterErrors((prev) => ({ ...prev, end_date: "" }));
    } else if (key.includes("posted_date")) {
      setFilterErrors((prev) => ({ ...prev, posted_date: "" }));
    }
  };

  const clearIndividualFilter = (field1, field2 = null) => {
    const updated = { ...localFilters, [field1]: "" };
    if (field2) updated[field2] = "";
    setLocalFilters(updated);
  };

  const handleClearFilterForm = () => {
    setLocalFilters({
      job_status: "",
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: ""
    });
    setFilterErrors({
      start_date: "",
      end_date: "",
      posted_date: ""
    });
  };

  const validateFilterDates = () => {
    const errors = { start_date: "", end_date: "", posted_date: "" };
    let isValid = true;

    const validateRange = (from, to, label) => {
      if (from && !to) {
        errors[label] = "End Date is required.";
        isValid = false;
      } else if (!from && to) {
        errors[label] = "Start Date is required.";
        isValid = false;
      } else if (from && to && new Date(from) > new Date(to)) {
        errors[label] = "End Date must be after Start Date.";
        isValid = false;
      }
    };

    validateRange(localFilters.start_date_from, localFilters.start_date_to, "start_date");
    validateRange(localFilters.end_date_from, localFilters.end_date_to, "end_date");
    validateRange(localFilters.posted_date_from, localFilters.posted_date_to, "posted_date");

    setFilterErrors(errors);
    return isValid;
  };

  const handleApplyFilter = () => {
    if (!validateFilterDates()) return;

    const transformedFilters = {
      ...localFilters,
      start_date_from: getUTCDateTime(localFilters.start_date_from),
      start_date_to: getUTCDateTime(localFilters.start_date_to, true),
      end_date_from: getUTCDateTime(localFilters.end_date_from),
      end_date_to: getUTCDateTime(localFilters.end_date_to, true),
      posted_date_from: getUTCDateTime(localFilters.posted_date_from),
      posted_date_to: getUTCDateTime(localFilters.posted_date_to, true),
    };

    onFilterChange(transformedFilters);
    setShowFilterDropdown(false);
  };

  const handleDeleteJob = async () => {
    try {
      const response = await apiClient.delete(`${jobsBaseUrl}/${jobToDelete.id}`);

      if (response.data.status === "SUCCESS") {
        showSuccessToast("Job deleted successfully");

        if (currentJobs.length === 1 && currentPage > 1) {
          onPageChange(1);
        } else {
          setRefresh(prev => !prev);
        }
      } else {
        const errorCode = response.data.error_data?.code;
        const errorMessage = response.data.error_data?.message || "Failed to delete job";

        if (errorCode === "JOB-DELETE-NOT-ALLOWED") {
          showErrorToast("You can only delete jobs with 'Not Started' status.");
        } else if (errorCode === "JOB-HAS-TRUCKS") {
          showErrorToast("This job cannot be deleted because trucks have already applied.");
        } else {
          showErrorToast(errorMessage);
        }
      }
    } catch (err) {
      console.error(err);
      if (err.response?.data?.error_data?.message) {
        showErrorToast(err.response.data.error_data.message);
      } else {
        showErrorToast("An unexpected error occurred while deleting the job.");
      }
    } finally {
      setShowDeleteModal(false);
    }
  };

  const handleClearAllFilters = () => {
    setLocalFilters({
      job_status: "",
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: ""
    });
    resetFilters();
    setShowFilterDropdown(false);
  };

  const isAnyFilterApplied = Object.values(filters).some((val) => Boolean(val));
  return (
    <>
      <div className="common-top exm-top">
        <div className="filter-cvr" ref={filterRef}>
          <a
            className={`filter-btn ${isAnyFilterApplied ? "active-filter" : ""}`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowFilterDropdown((prev) => !prev);
            }}
          >
            <span className="filter-icon-wrapper">
              <img className="ct-icon" src={filterIcon} alt="filter" />
              {isAnyFilterApplied && <span className="filter-indicator-dot"></span>}
            </span>
            Filter
          </a>

          <a
            className="clear-btn"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleClearAllFilters();
            }}
          >
            <img className="ct-icon" src={clearIcon} alt="clear" />
            Clear Filter
          </a>

          {showFilterDropdown && (
            <ul className="dropdown-menu filterdrop-body show dropstyle">

              {/* Job Type */}
              <div className="filterdrop-split">
                <label className="filter-label">Job Type
                  {localFilters.job_type && (
                    <img
                      className="red-close"
                      src={closeRedIcon}
                      alt="remove"
                      onClick={() => clearIndividualFilter("job_type")}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
                <select
                  className="filter-select"
                  value={localFilters.job_type}
                  onChange={(e) => handleLocalFilterChange("job_type", e.target.value)}
                >
                  <option value="">--select--</option>
                  <option value="Paving">Paving</option>
                  <option value="Dirt Hauling">Dirt Hauling</option>
                  <option value="Gravel Supply">Gravel Supply</option>
                </select>
              </div>

              {/* Truck Type */}
              <div className="filterdrop-split">
                <label className="filter-label">Truck Type
                  {localFilters.truck_type && (
                    <img
                      className="red-close"
                      src={closeRedIcon}
                      alt="remove"
                      onClick={() => clearIndividualFilter("truck_type")}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
                <select
                  className="filter-select"
                  value={localFilters.truck_type}
                  onChange={(e) => handleLocalFilterChange("truck_type", e.target.value)}
                >
                  <option value="">--select--</option>
                  <option value="Tri-Axle Dump Truck">Tri-Axle Dump Truck</option>
                </select>
              </div>

              {/* Job Starting Date */}
              <div className="filterdrop-split">
                <label className="filter-label">Job Starting Date
                  {(localFilters.start_date_from || localFilters.start_date_to) && (
                    <img
                      className="red-close"
                      src={closeRedIcon}
                      alt="remove"
                      onClick={() => clearIndividualFilter("start_date_from", "start_date_to")}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
                <div className="filter-datepicker from-date">
                  <DatePicker
                    selected={localFilters.start_date_from ? new Date(localFilters.start_date_from) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("start_date_from", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="Start Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                <div className="filter-datepicker to-date">
                  <DatePicker
                    selected={localFilters.start_date_to ? new Date(localFilters.start_date_to) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("start_date_to", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="End Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                {filterErrors.start_date && (
                  <div className="error-text active">{filterErrors.start_date}</div>
                )}
              </div>

              {/* Job Ending Date */}
              <div className="filterdrop-split">
                <label className="filter-label">Job Ending Date
                  {(localFilters.end_date_from || localFilters.end_date_to) && (
                    <img
                      className="red-close"
                      src={closeRedIcon}
                      alt="remove"
                      onClick={() => clearIndividualFilter("end_date_from", "end_date_to")}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
                <div className="filter-datepicker from-date">
                  <DatePicker
                    selected={localFilters.end_date_from ? new Date(localFilters.end_date_from) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("end_date_from", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="Start Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                <div className="filter-datepicker to-date">
                  <DatePicker
                    selected={localFilters.end_date_to ? new Date(localFilters.end_date_to) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("end_date_to", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="End Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                {filterErrors.end_date && (
                  <div className="error-text active">{filterErrors.end_date}</div>
                )}
              </div>

              {/* Posted Date */}
              <div className="filterdrop-split">
                <label className="filter-label">Posted Date
                  {(localFilters.posted_date_from || localFilters.posted_date_to) && (
                    <img
                      className="red-close"
                      src={closeRedIcon}
                      alt="remove"
                      onClick={() => clearIndividualFilter("posted_date_from", "posted_date_to")}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
                <div className="filter-datepicker from-date">
                  <DatePicker
                    selected={localFilters.posted_date_from ? new Date(localFilters.posted_date_from) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("posted_date_from", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="Start Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                <div className="filter-datepicker to-date">
                  <DatePicker
                    selected={localFilters.posted_date_to ? new Date(localFilters.posted_date_to) : null}
                    onChange={(date) =>
                      handleLocalFilterChange("posted_date_to", date ? date.toLocaleDateString("en-CA") : "")
                    }
                    placeholderText="End Date"
                    className="filter-date"
                    dateFormat={DATE_MONTH_FORMAT}
                  />
                  <span className="filter-calendar-icon">
                    <img src={calendarIcon} alt="calendar" />
                  </span>
                </div>
                {filterErrors.posted_date && (
                  <div className="error-text active">{filterErrors.posted_date}</div>
                )}
              </div>

              {/* Filter Buttons */}
              <div className="filterdrop-split mb-0">
                <div className="filter-buttons">
                  <a
                    href="#"
                    className="filter-clear"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClearFilterForm();
                    }}
                  >
                    Clear
                  </a>
                  <a
                    href="#"
                    className="filter-apply"
                    onClick={(e) => {
                      e.preventDefault();
                      handleApplyFilter();
                    }}
                  >
                    Apply
                  </a>
                </div>

              </div>
            </ul>
          )}
        </div>
        <div className="search-bar">
          <form onSubmit={(e) => e.preventDefault()}>
            <input
              className="form-control me-2"
              type="search"
              placeholder="Search Term"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <button className="ser-submit" type="submit">
              <img src={searchIcon} alt="search" />
            </button>
          </form>
        </div>
      </div>

      <div className="table-cvr">
        <div className="table-inner">
          <table id="jobTable" className="table nowrap">
            <thead>
              <tr>
                <th className="col-jobno text-middle">#</th>
                <th className="col-jobid">Job ID</th>
                <th className="col-jobtype">Job Type</th>
                <th className="col-location">Start Location</th>
                <th className="col-location">Dump Location</th>
                <th className="col-time">Start Time</th>
                <th className="col-time">End Time</th>
                <th className="col-paytype">Payment Type</th>
                <th className="col-payrate">Pay Rate</th>
                <th className="col-trucktype">Truck Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="13" className="text-center py-4">
                    <ClipLoader size={30} color="gray" />
                  </td>
                </tr>
              ) : currentJobs.length > 0 ? (
                currentJobs.map((job, index) => (
                  <tr key={job.id}>
                    <td className="text-middle">{startIndex + index + 1}</td>
                    <td>
                      <a
                        className="vu-link"
                        href="#"
                        style={{
                          color: "#59a52c",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setJobData(job);

                          const modalEl = document.getElementById("viewJob");
                          const modalInstance = new bootstrap.Modal(modalEl);
                          modalInstance.show();
                        }}
                      >
                        {job.job_name}
                      </a>

                    </td>
                    <td>{job.job_type}</td>
                    <td>{job.start_location ? job.start_location : `(${job.start_location_latitude}, ${job.start_location_longitude})`}</td>
                    <td>{job.end_location ? job.end_location : `(${job.end_location_latitude}, ${job.end_location_longitude})`}</td>
                    <td>{moment.utc(job.start_date_time).local().format(DATE_TIME_FORMAT)}</td>
                    <td>{moment.utc(job.end_date_time).local().format(DATE_TIME_FORMAT)}</td>
                    <td>{job.payment_type}</td>
                    <td>{job.payment_rate}</td>
                    <td>{job.truck_type}</td>
                    <td>
                      {!isUser && (
                        <button onClick={() => handleApplyClick(job)} disabled={job.num_trucks_applied >= job.num_trucks_required} style={{ backgroundColor: job.num_trucks_applied >= job.num_trucks_required ? "#ccc" : "#59a52c", color: "white", border: "none", borderRadius: "6px", padding: "6px 14px", cursor: job.num_trucks_applied >= job.num_trucks_required ? "not-allowed" : "pointer", fontWeight: "500", }} >
                          Apply
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center py-4 text-muted">
                    No jobs found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalJobs}
          itemsPerPage={jobsPerPage}
          setItemsPerPage={setJobsPerPage}
          onPageChange={onPageChange}
        />
        
      </div>

      <ConfirmationModal
        id="deleteJobModal"
        show={showDeleteModal}
        title="Delete Job"
        message={`Are you sure you want to delete this ${jobToDelete?.job_name || "job"}?`}
        confirmText="Yes"
        cancelText="Cancel"
        onConfirm={handleDeleteJob}
        onCancel={() => setShowDeleteModal(false)}
      />

      {showAssignModal && (
        <AssignModal show={showAssignModal} onClose={handleCloseModal} job={selectedJob} />
      )}
    </>
  );
};

export default JobTableSection;
